export default __webpack_public_path__ + "static/media/Steelspirit Gauntlets.e60f7e31.jpg";